import { useEffect, useState } from "react";
import { useProvider, Toast, isNative } from '../../context/MenuProvider'


const OpenAppBanner = () => {
  const { 
    buscarDadosPorId,
    crud,
    site
  } = useProvider();
  const { loading, get, post } = crud || {};
  const [showBanner, setShowBanner] = useState(false);
  const [pacote, setPacote] = useState(null);

  const abrirApp = () => {
    if (isNative) return;
  
    const ua = navigator.userAgent.toLowerCase();
    const isIOS = /iphone|ipad|ipod/.test(ua);
    const packageName = isIOS ? site?.pacote_ios : site?.pacote_android;
    const isPWA = window.matchMedia('(display-mode: standalone)').matches;
  
    if (packageName) {
      if (!isIOS) {
        // Android: tenta abrir app nativo, Play Store se não tiver
        const fallbackUrl = `https://play.google.com/store/apps/details?id=${packageName}`;
        window.location.href = `intent://#Intent;package=${packageName};end;S.browser_fallback_url=${encodeURIComponent(fallbackUrl)}`;
      } else {
        // iOS: tenta abrir app nativo pelo URL scheme ou App Store se não tiver
        const iosScheme = site?.ios_scheme; // Ex: gvendas://
        const fallbackUrl = `https://apps.apple.com/app/id${packageName}`; // packageName = App Store ID
        window.location.href = `${iosScheme || ''}`;
        // fallback automático não funciona no iOS via JS puro, então podemos usar timeout
        setTimeout(() => {
          window.location.href = fallbackUrl;
        }, 1500);
      }
    } else {
      // Não tem pacote → abrir PWA
      if (!isPWA) {
        if (window.deferredPrompt) {
          window.deferredPrompt.prompt();
        } else {
          alert('Abra pelo App para ter a melhor experiência!');
        }
      }
      // Se já estiver no PWA, não precisa fazer nada
    }
  };

  useEffect(() => {
    const isAndroid = /android/i.test(navigator.userAgent);
    const isInStandalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (isAndroid && !isInStandalone && !showBanner) {
      setShowBanner(true);
    }
    if(isAndroid) setPacote(site?.pacote_android);
  }, [loading]);
  
  if (!showBanner || !pacote || isNative) return null;

  return (
    <div style={{ background: "#f1f1f1", padding: "15px", textAlign: "center" }}>
      <p>Experimente nosso app para uma experiência melhor!</p>
      <a
        onClick={abrirApp}
        //href={`intent://${url}/#Intent;scheme=https;package=${pacote};end;`}
        className="download-btn fs-4 px-5"
      >
        Abrir no App
      </a>
    </div>
  );
}

export default OpenAppBanner;